import { useTheme } from "@mui/material"
import { ReactComponent as Logo } from './NotFound.svg';
const NotFoundSvg = () => {
    return <Logo fill={useTheme().palette.primary.main} width={"50vw"} height={"50vh"} />;
}

export default NotFoundSvg